import React, { Component } from "react";
import { DatePicker, Form } from 'antd';
import moment from "moment";
export default class DateContainer extends Component {
  disabledDate = current => {
    return current < moment('1900-01-01') || current > moment('2101-01-01');
  };

  render() {
    const {
      data,
      index,
      sceneCode
    } = this.props;
    const {
      getFieldDecorator
    } = this.props.form;
    const defaultValue = data.value ? moment(data.value, "YYYY-MM-DD") : null;
    const conDate = getFieldDecorator(JSON.stringify(data.fieldId), {
      rules: [{
        required: data.required,
        validator: (rule, value, callback) => {
          let val = value || "";

          if (data.required && val === "") {
            callback('必填项，请输入相关信息');
            return;
          }

          callback();
        }
      }],
      initialValue: defaultValue
    })(<DatePicker data-inspector-line="29" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\DateContainer\\index.jsx" disabledDate={this.disabledDate} disabled={data.frontUpdateFlag === 1} getCalendarContainer={triggerNode => triggerNode.parentNode} placeholder={sceneCode && sceneCode == '1' && data.fieldTip ? data.fieldTip : "请选择日期"} />);
    return <div data-inspector-line="37" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\DateContainer\\index.jsx" className="detail-sel-date detail-sel-wrap">
        <Form.Item data-inspector-line="38" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\DateContainer\\index.jsx">
          {conDate}
        </Form.Item>
      </div>;
  }

}